import React from "react"
import { Route, Switch } from "react-router-dom"
import BaseLayout from "src/layouts/Base"
import ReportTemplates from "src/containers/ReportTemplates"
import {
  REPORT_TEMPLATES_URL,
  REPORT_TEMPLATES_ID_URL,
} from "src/constants/routeNames"

const ReportTemplatePage = (
  <BaseLayout title="Шаблоны отчетов">
    <Switch>
      <Route path={REPORT_TEMPLATES_URL} exact component={ReportTemplates} />
      <Route path={REPORT_TEMPLATES_ID_URL} component={ReportTemplates} />
    </Switch>
  </BaseLayout>
)

export default (
  <Route path={REPORT_TEMPLATES_URL}>
    <Switch>
      <Route path={REPORT_TEMPLATES_URL} exact>
        {ReportTemplatePage}
      </Route>
      <Route path={REPORT_TEMPLATES_ID_URL}>{ReportTemplatePage}</Route>
    </Switch>
  </Route>
)
